import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PagesGuard } from '../core/auth/guards/pages.guard';
import { ModuleAccessGuard } from '../core/auth/guards/moduleAccessGuard.guard';
import { ModuleKey } from '../core/constants/module-status.enum';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'insights',
    pathMatch: 'full'
  },
  {
    path: 'insights',
    loadComponent: () => import('./dashboard/dashboard.component').then(c => c.DashboardComponent),
    canActivate: [PagesGuard],
  },
  {
    path: 'forecasting',
    loadChildren: () => import('./forecasting/forecasting.module').then(m => m.ForecastingModule),
    canActivate: [PagesGuard, ModuleAccessGuard],
    data: { requiredModuleKey: ModuleKey.FORECASTING }
  },
  {
    path: 'reconciliation',
    loadChildren: () => import('./reconciliation/reconciliation.module').then(m => m.ReconciliationModule),
    canActivate: [PagesGuard, ModuleAccessGuard],
    data: { requiredModuleKey: ModuleKey.RECONCILIATION }
  },
  {
    path: 'cash-analysis',
    loadChildren: () => import('./cash-management/cash-analysis/cash-analysis.module').then(m => m.CashAnalysisModule),
    canActivate: [PagesGuard],
  },
  {
    path: 'transactions',
    loadChildren: () => import('./cash-management/transactions/transactions.module').then(m => m.TransactionsModule),
    canActivate: [PagesGuard]
  },
  {
    path: 'cash-positioning',
    loadChildren: () => import('./cash-management/cash-positioning/cash-positioning.module').then(m => m.CashPositioningModule),
    canActivate: [PagesGuard, ModuleAccessGuard],
    data: { requiredModuleKey: ModuleKey.CASH_POSITIONING }
  },
  {
    path: 'cash-reporting',
    loadChildren: () => import('./cash-management/cash-reporting/cash-reporting.module').then(m => m.CashReportingModule),
    canActivate: [PagesGuard]
  },
  {
    path: 'import-management',
    loadChildren: () => import('./import-management/import-management.module').then(m => m.ImportManagementModule),
    canActivate: [PagesGuard, ModuleAccessGuard],
    data: { requiredModuleKey: ModuleKey.MANUAL_BANK_STATEMENT }
  },
  {
    path: 'profile',
    loadChildren: () => import('./profile/profile.module').then(m => m.ProfileModule),
    canActivate: [PagesGuard]
  },
  {
    path: 'notifications',
    loadComponent: () => import('./notifications/notifications.component').then(m => m.NotificationsComponent),
    canActivate: [PagesGuard]
  },
  {
    path: 'setup',
    loadChildren: () => import('./business-account/business-account.routes').then((m) => m.BUSINESS_ACCOUNT_ROUTES),
    canActivate: [PagesGuard]
  },
  {
    path: 'open-banking',
    loadChildren: () => import('./open-banking/open-banking.module').then(m => m.OpenBankingModule),
    canActivate: [PagesGuard, ModuleAccessGuard],
    data: { requiredModuleKey: ModuleKey.OPEN_BANKING }
  },
  {
    path: 'payments',
    loadChildren: () => import('./payments/payments.routes').then((m) => m.PAYMENTS_ROUTES),
    canActivate: [PagesGuard, ModuleAccessGuard],
    data: { requiredModuleKey: ModuleKey.PAYMENTS }
  },
  {
    path: 'AI-assistant',
    loadChildren: () => import('./deben-AI-assistant/deben-AI-assistant.module').then(m => m.DebenAiAssistantModule),
    canActivate: [PagesGuard, ModuleAccessGuard],
    data: { requiredModuleKey: ModuleKey.AI_ASSISTANT }
  },
  {
    path: 'developer',
    loadChildren: () => import('./developer/developer.module').then(m => m.DeveloperModule),
    canActivate: [PagesGuard]
  },
  // {
  //   path: 'getting-started',
  //   loadChildren: () => import('./getting-started/getting-started.module').then(m => m.GettingStartedModule)
  // }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesRoutingModule { }
